import { render, staticRenderFns } from "./ItemD_Details.vue?vue&type=template&id=31979308"
import script from "./ItemD_Details.vue?vue&type=script&lang=js"
export * from "./ItemD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports